import { useState, useEffect, useCallback } from "react";
import { getDecodedHtml } from "utils/getDecodedHtml";
import { ImageArrow } from "components/utility/images";
const MediaContacts = ({ additionalContent }) => {
	const { contacts, title, phoneText } = additionalContent;
	const [updatedContacts, setUpdatedContacts] = useState([]);
	const [isOpen, setOpen] = useState(false);
	const updateContacts = useCallback(
		(contacts) => {
			contacts.forEach((contact) => (contact.phone = `${phoneText}: ${contact.phone}`));
			return contacts;
		},
		[phoneText]
	);
	useEffect(() => {
		if (contacts.length > 0) {
			let arr = [...contacts];
			setUpdatedContacts(updateContacts(arr));
		}
	}, [contacts, contacts.length, updateContacts]);
	function openContacts() {
		setOpen(!isOpen);
	}
	return (
		<div className="media-contacts-container">
			<div className="media-contacts">
				<div
					className="media-contacts-title"
					dangerouslySetInnerHTML={{ __html: getDecodedHtml(title) }}
				></div>
				<div className="media-contacts-info-list">
					{updatedContacts.map((item) => {
						return (
							<div key={item.name} className="media-contacts-info">
								<div
									className="media-contacts-info-country"
									dangerouslySetInnerHTML={{ __html: getDecodedHtml(item.country) }}
								></div>
								<div
									className="media-contacts-info-name"
									dangerouslySetInnerHTML={{ __html: getDecodedHtml(item.name) }}
								></div>
								<div
									className="media-contacts-info-email"
									dangerouslySetInnerHTML={{ __html: getDecodedHtml(item.email) }}
								></div>
								<div
									className="media-contacts-info-phone"
									dangerouslySetInnerHTML={{ __html: getDecodedHtml(item.phone) }}
								></div>
							</div>
						);
					})}
				</div>
				<div className="media-center-contacts-small-triangle"></div>
			</div>
			<div
				className="media-contacts-mobile"
				onClick={openContacts}
				onKeyDown={openContacts}
				role="button"
				tabIndex={0}
			>
				<div className="media-contacts-mobile-ribbon" aria-expanded={isOpen}>
					<div className={`media-contacts-mobile-ribbon-header ${isOpen ? "remove" : ""}`}>
						<div className="media-contacts-mobile-ribbon-caret">
							<ImageArrow />
						</div>
						<div
							className={`media-contacts-mobile-ribbon-title`}
							dangerouslySetInnerHTML={{ __html: getDecodedHtml(title) }}
						></div>
					</div>

					<div
						className={`media-contacts-mobile-ribbon-section ${
							isOpen ? "show-ribbon" : "hide-ribbon"
						}`}
					>
						<div className="media-contacts-info-list">
							{contacts.map((item) => {
								return (
									<div key={`${item.name}-mobile`} className="media-contacts-info">
										<div
											className="media-contacts-info-country"
											dangerouslySetInnerHTML={{ __html: getDecodedHtml(item.country) }}
										></div>
										<div
											className="media-contacts-info-name"
											dangerouslySetInnerHTML={{ __html: getDecodedHtml(item.name) }}
										></div>
										<div
											className="media-contacts-info-email"
											dangerouslySetInnerHTML={{ __html: getDecodedHtml(item.email) }}
										></div>
										<div
											className="media-contacts-info-phone"
											dangerouslySetInnerHTML={{ __html: getDecodedHtml(item.phone) }}
										></div>
									</div>
								);
							})}
						</div>
					</div>
				</div>
			</div>
			<div
				className={`body-mask body-mask-${isOpen ? "show" : "hide"}  media-center-mask `}
				onClick={openContacts}
				onKeyDown={openContacts}
				role="button"
				tabIndex={-1}
			></div>
		</div>
	);
};

export default MediaContacts;
